import { useEffect, useState } from "react";
import { api } from "../lib/api";

interface WorkIcon {
    id: number;
    icon: string;
    iconUrl: string;
}

export const useWorksIcons = () => {
    const [icons, setIcons] = useState<WorkIcon[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const fetchIcons = async () => {
            setIsLoading(true);
            try {
                const data = await api.getWorks();

                type WorkRow = { id: number; name: string; icon_path: string | null };
                const iconsWithUrls: WorkIcon[] = (data as WorkRow[])
                    .map((item): WorkIcon | null => {
                        if (!item.icon_path) return null;
                        return {
                            id: item.id,
                            icon: item.name,
                            iconUrl: api.getImageUrl(item.icon_path)
                        };
                    })
                    .filter((icon): icon is WorkIcon => icon !== null);

                setIcons(iconsWithUrls);
            } catch (err) {
                console.error("Error in fetchIcons:", err);
                setError(err instanceof Error ? err : new Error("Unknown error"));
            } finally {
                setIsLoading(false);
            }
        };

        fetchIcons();
    }, []);

    return { icons, isLoading, error };
};
